import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	ArchivedFilterEnum,
	getPortfolioV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Options = {
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[];
	onlyReportingEnabled?: boolean;
	archived?: ArchivedFilterEnum;
	enabled?: boolean;
};

export const usePortfolioListQuery = ({
	filterDatagroups,
	onlyReportingEnabled,
	// TODO: the port folio list should pass the user-selected archived filter once FE archiving is done
	archived = ArchivedFilterEnum.All,
	enabled = true,
}: Options = {}) => {
	return useQuery({
		queryKey: PortfolioKeys.portfolioList(
			filterDatagroups,
			onlyReportingEnabled,
			archived,
		),
		queryFn: ({ signal }) =>
			processResponse(() =>
				getPortfolioV2(filterDatagroups, onlyReportingEnabled, archived, {
					signal,
				}),
			)(undefined),
		enabled,
	});
};
